import { createInput, defineFormKitConfig } from '@formkit/vue'
import { generateClasses } from '@formkit/themes'
import { createMultiStepPlugin } from '@formkit/addons'
import { primeInputs } from '@sfxcode/formkit-primevue'
import FormKitCountrySelect from '~/components/form-kit/FormKitCountrySelect.vue'
import FormKitOptionsMultiSelect from '~/components/form-kit/FormKitOptionsMultiSelect.vue'
import FormKitFundAccountSelect from '~/components/form-kit/FormKitFundAccountSelect.vue'
import FormKitEmployeeSelect from '~/components/form-kit/FormKitEmployeeSelect.vue'
import FormKitContactSelect from '~/components/form-kit/FormKitContactSelect.vue'
import FormKitCharitySelect from '~/components/form-kit/FormKitCharitySelect.vue'
import FormKitCampaignSelect from '~/components/form-kit/FormKitCampaignSelect.vue'
import FormKitOptionCards from '~/components/form-kit/FormKitOptionCards.vue'
import ToggleablePassword from '~/../member-webapp-shared/components/forms/ToggleablePassword.vue'
import OneTimePassword from '~/../member-webapp-shared/components/forms/OneTimePassword.vue'
import { formKitCurrencyInput } from '~/../member-webapp-shared/lib/formkit/currency-input'

import '@formkit/addons/css/multistep'

export default defineFormKitConfig(() => {
  const customInputs = {
    countrySelect: createInput(FormKitCountrySelect, {
      type: 'input',
      props: ['taglist', 'placeholder', 'filter', 'showClear', 'options'],
    }),
    optionsMultiSelect: createInput(FormKitOptionsMultiSelect, {
      type: 'input',
      props: ['placeholder', 'filter', 'showClear', 'options', 'ariaLabel'],
    }),
    fundAccountSelect: createInput(FormKitFundAccountSelect, {
      type: 'input',
      props: ['adminFeeIssueFilter', 'placeholder', 'pageSize'],
    }),
    employeeSelect: createInput(FormKitEmployeeSelect, {
      type: 'input',
      props: [
        'placeholder',
        'showClear',
        'activeOnly',
        'requireLicence',
        'roleIds',
      ],
    }),
    contactSelect: createInput(FormKitContactSelect, {
      type: 'input',
      props: ['placeholder', 'pageSize', 'minSearchLength'],
    }),
    charitySelect: createInput(FormKitCharitySelect, {
      type: 'input',
    }),
    campaignSelect: createInput(FormKitCampaignSelect, {
      type: 'input',
      props: ['placeholder', 'currentEventId'],
    }),
    optionCards: createInput(FormKitOptionCards, {
      props: ['cards'],
    }),
    toggleablePassword: createInput(ToggleablePassword, {
      type: 'input',
      family: 'text',
    }),
    oneTimePassword: createInput(OneTimePassword, {
      type: 'input',
      props: ['digits'],
    }),
    currency: formKitCurrencyInput,
  }

  return {
    config: {
      useInputDecorators: false,
      classes: generateClasses({
        global: {
          help: 'mt-1 text-sm text-fp-gray-5 mb-2',
          label: 'input-label',
          legend: 'input-label',
          option: 'mt-2 space-y-1',
          messages: 'bg-fp-red-2 rounded mt-1 px-3 py-1 gap-x-2',
          message: 'text-fp-red-7 text-sm-med',
        },
        'family:box': {
          wrapper: 'flex mb-1',
          element: 'flex items-center',
          label: 'block text-sm text-fp-gray-6 mt-[3px] ml-[-3px] font-normal',
          inner: 'flex items-center',
          input: 'mr-3',
        },
      }),
    },
    plugins: [createMultiStepPlugin()],
    inputs: { ...customInputs, ...primeInputs },
  }
})
